/** Strings for the GitHub App setup pages (S12) and the connection panel (S13). */
export const githubCopy = {
  title: 'Connect GitHub',
  crumbs: { workspace: 'workspace', resources: 'resources', current: 'github' },
  connection: {
    disconnected:
      'The App was uninstalled on GitHub — reconnect to reinstall it.',
    reconnect: 'Reconnect',
    reconnectFailed: (reason: string) => `Failed to reconnect — ${reason}`,
  },
  startOver: {
    /** One sentence; `{link}` is where the Resources link goes. */
    sentence: 'Start over by adding a GitHub connection in {link}.',
    link: 'Resources',
  },
  callback: {
    noCode: 'GitHub did not return a setup code.',
    exchangeFailed: (reason: string) =>
      `Failed to finish GitHub App setup — ${reason}`,
  },
  installed: {
    noFlow: 'No GitHub App setup is in progress in this tab.',
    noAuthorization:
      'GitHub did not ask you to authorize the App, so the installation cannot be verified. The App must have "Request user authorization (OAuth) during installation" enabled.',
    claimFailed: (reason: string) =>
      `Failed to connect the GitHub installation — ${reason}`,
  },
} as const
